// require("dotenv").config();
// const express =require("express");
// const app =express();
// const http =require('http')
// const {PORT}=process.env
// const userRouter = require('../route/users')


// app.use("/api/v1",userRouter)

// http.createServer(app).listen(PORT,(req,res)=>{
//   console.log("server has been created on"+PORT);

// })










import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Elements } from "@stripe/react-stripe-js";
import { stripePromise } from "./stripe";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Elements stripe={stripePromise}>

      <App />
    </Elements>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
